import(/* webpackMode: "eager" */ "/app/app/(legal)/[lang]/privacy/page.tsx");
